'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".EddPanel-module_container__JOXw-{display:flex;flex-direction:column;max-width:952px}.EddPanel-module_containerLandscape__eyeY8{flex-direction:row}.EddPanel-module_columnLeft__JIgIX{width:100%}.EddPanel-module_columnLeftLandscape__jm6SH{border-right:1px solid #d3d3d3;padding-right:1rem;width:12rem}.EddPanel-module_columnRight__w8GR0{width:100%}.EddPanel-module_columnRightLandscape__wUTeE{flex:1;padding-left:2rem}";
var styles = {"container":"EddPanel-module_container__JOXw-","containerLandscape":"EddPanel-module_containerLandscape__eyeY8","columnLeft":"EddPanel-module_columnLeft__JIgIX","columnLeftLandscape":"EddPanel-module_columnLeftLandscape__jm6SH","columnRight":"EddPanel-module_columnRight__w8GR0","columnRightLandscape":"EddPanel-module_columnRightLandscape__wUTeE"};
styleInject["default"](css_248z, '58b211a5-2f54-4432-91b7-779b7d4655cb');

exports["default"] = styles;
